import React from 'react';
import { Nav } from '../components/landing/Nav';
import { Hero } from '../components/landing/Hero';
import { Hook } from '../components/landing/Hook';
import { Problem } from '../components/landing/Problem';
import { FailedAttempts } from '../components/landing/FailedAttempts';
import { Mechanism } from '../components/landing/Mechanism';
import { WhatYouGet } from '../components/landing/WhatYouGet';
import { ForWhom } from '../components/landing/ForWhom';
import { HowItWorks } from '../components/landing/HowItWorks';
import { Proof } from '../components/landing/Proof';
import { FAQ } from '../components/landing/FAQ';
import { Offer } from '../components/landing/Offer';
import { Footer } from '../components/landing/Footer';
export default function Landing() {
  return <div className="min-h-screen flex flex-col overflow-x-hidden" data-id="element-243">
      <Nav data-id="element-244" />
      <main className="flex-grow" data-id="element-245">
        <Hero data-id="element-246" />
        <Hook data-id="element-247" />
        <Problem data-id="element-248" />
        <FailedAttempts data-id="element-249" />
        <Mechanism data-id="element-250" />
        <WhatYouGet data-id="element-251" />
        <ForWhom data-id="element-252" />
        <HowItWorks data-id="element-253" />
        <Proof data-id="element-254" />
        <FAQ data-id="element-255" />
        <Offer data-id="element-256" />
      </main>
      <Footer data-id="element-257" />
    </div>;
}